import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { useSelector } from 'react-redux'
import { useStyles } from './styles'
import { NavLink } from 'react-router-dom'
import DeviceStatusBadge from 'web/src/app/root/components/common/device-status-badge'

export const DeviceBasicInfo = ({
    deviceStatusText,
    device,
    isTom,
    severity,
    isJerryBaitRat,
    locationSettings
}) => {
    const { locale, theme } = useSelector(state => state.main)
    const classes = useStyles()
    const baitSettings =
        locationSettings?.data?.bait_settings &&
        !device.override_location_settings
            ? locationSettings.data.bait_settings
            : device
    const hasLocationBaitSettings = Boolean(
        locationSettings?.data?.bait_settings
    )

    return (
        <>
            <table
                style={{
                    width: 440,
                    height: 'auto',
                    borderCollapse: 'collapse'
                }}>
                <tr>
                    <th className={classes.tableTh}>
                        <Typography className={classes.leftCellText} noWrap>
                            {locale.devices.status}:
                        </Typography>
                    </th>
                    <td className={classes.tableTd}>
                        <Typography className={classes.rightCellText}>
                            {deviceStatusText}
                        </Typography>
                    </td>
                </tr>
                <tr>
                    <th className={classes.tableTh}>
                        <Typography className={classes.leftCellText} noWrap>
                            {locale.devices.serialNr}:
                        </Typography>
                    </th>
                    <td className={classes.tableTd}>{device.serial_number}</td>
                </tr>
                <tr>
                    <th className={classes.tableTh}>
                        <Typography className={classes.leftCellText} noWrap>
                            {locale.devices.pestControlSystem}:
                        </Typography>
                    </th>
                    <td className={classes.tableTd}>
                        <Typography className={classes.rightCellText}>
                            {locale.devices.pestControlSystems[
                                device.pest_control_system_id
                            ] || 'N/A'}
                        </Typography>
                    </td>
                </tr>
                <tr>
                    <th className={classes.tableTh}>
                        <Typography className={classes.leftCellText} noWrap>
                            {locale.devices.location}:
                        </Typography>
                    </th>
                    <td className={classes.tableTd}>
                        {device.is_assigned ? (
                            <Typography className={classes.rightCellText}>
                                <NavLink
                                    className={classes.link}
                                    to={`/locations/${device.location_id}/devices`}>
                                    {device.location_name}
                                </NavLink>
                            </Typography>
                        ) : (
                            <Typography className={classes.rightCellText}>
                                {device.location_name}
                            </Typography>
                        )}
                    </td>
                </tr>

                <tr>
                    <th className={classes.tableTh}>
                        <Typography className={classes.leftCellText}>
                            {locale.devices.organisation}:
                        </Typography>
                    </th>
                    <td className={classes.tableTd}>
                        <Typography className={classes.rightCellText}>
                            {device.customer_name}
                        </Typography>
                    </td>
                </tr>

                {isJerryBaitRat ? (
                    <tr>
                        <th className={classes.tableTh}>
                            <Typography className={classes.leftCellText}>
                                {locale.devices.baitType}:
                            </Typography>
                        </th>
                        <td className={classes.tableTd}>
                            <Typography className={classes.rightCellText}>
                                {baitSettings.bait_manufacturer_and_type ||
                                    '--'}{' '}
                                {baitSettings.bait_weight_grams
                                    ? `${baitSettings.bait_weight_grams}g`
                                    : '--'}
                            </Typography>
                        </td>
                    </tr>
                ) : null}
                {isJerryBaitRat && hasLocationBaitSettings ? (
                    <tr>
                        <th className={classes.tableTh}>
                            <Typography className={classes.leftCellText}>
                                {locale.devices.baitAndActivitySettings}:
                            </Typography>
                        </th>
                        <td className={classes.tableTd}>
                            <Typography className={classes.rightCellText}>
                                {device.override_location_settings ? (
                                    <NavLink
                                        className={classes.link}
                                        to={`/devices/${device.id}/settings`}>
                                        {locale.devices.deviceSettingsSource}
                                    </NavLink>
                                ) : (
                                    <>
                                        {
                                            locale.devices
                                                .monitoringValuesSetForLocation
                                        }{' '}
                                        <NavLink
                                            className={classes.link}
                                            to={`/locations/${device.location_id}/settings`}>
                                            {device.location_name}
                                        </NavLink>
                                    </>
                                )}
                            </Typography>
                        </td>
                    </tr>
                ) : null}

                {!isJerryBaitRat ? (
                    <tr>
                        <th className={classes.tableTh}>
                            <Typography className={classes.leftCellText} noWrap>
                                {isTom
                                    ? locale.tom.system
                                    : locale.devices.traps}
                                :
                            </Typography>
                        </th>
                        <td className={classes.tableTd}>
                            <Box style={{ display: 'flex' }}>
                                <DeviceStatusBadge
                                    device={device}
                                    locale={locale}
                                    theme={theme}
                                    severity={severity}
                                />
                            </Box>
                        </td>
                    </tr>
                ) : null}
            </table>
        </>
    )
}
